import { cutString } from './cutString'

export const addEllipsisEnding = (str: string, maxLettersNumber: number) =>
  str.length <= maxLettersNumber
    ? str
    : `${cutString(str, maxLettersNumber)}...`
